const PublicPageStyles = () => (
  <>
    <link media="all" href="/wordpress_design.css" rel="stylesheet" />
    <link
      rel="stylesheet"
      id="google-fonts-css"
      href="https://fonts.googleapis.com/css?family=Roboto%3A300%2C400%7CPlayfair+Display&amp;display=swap&amp;ver=0.5.3.1577824173"
      type="text/css"
      media="all"
    />
    <link
      rel="stylesheet"
      id="font-awesome-css"
      href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css?ver=0.5.3.1577824173"
      type="text/css"
      media="all"
    />
  </>
);

export default PublicPageStyles;
